export const labelTooltip =
  'Generated upon printing a label for an inventory. Consists of "Pickup ID - Line ID". Line ID being the inventory\'s sequential position in a pickup.';
